
<template>
  <div :class="className" :style="{ height: height, width: width }" ref="chart"></div>
</template>

<script>
export default {
  name: 'ECharts',
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    options: {
      type: Object,
      required: true
    },
    height: {
      type: String,
      default: '400px'
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$refs.chart)
      this.chart.setOption(this.options,true)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler(newVal) {
        if (this.chart) {
          this.chart.setOption(newVal,true)
        }
      }
    }
  }
}
</script>

<style scoped>
.chart {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>